<script setup lang="ts">
const emit = defineEmits<{
    click: [];
}>();
</script>

<template>
    <UButton color="primary-dark" size="sm" icon="lucide:expand" @click="emit('click')" />
</template>
